import { render } from "./ContactsSupport.vue?vue&type=template&id=2fa76fa2&scoped=true"
import script from "./ContactsSupport.vue?vue&type=script&lang=js"
export * from "./ContactsSupport.vue?vue&type=script&lang=js"

import "./ContactsSupport.vue?vue&type=style&index=0&id=2fa76fa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa76fa2"]])

export default __exports__